import { render, staticRenderFns } from "./NotificationData.vue?vue&type=template&id=7df53254&"
import script from "./NotificationData.vue?vue&type=script&lang=js&"
export * from "./NotificationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports